import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { BaseDataResponse, BaseEntityResponse, ItemPriceInfo } from "@base/entities/BaseEntities";
import { BaseEndpoint } from "@base/endpoint/BaseEndpoint";
import { APIGatewayService } from "../gateway/APIGateway.service";


@Injectable()
export class GeneralEndpoint extends BaseEndpoint  
{
    public constructor(api: APIGatewayService)
    {
        super("General", api);
    }

    public CalculateConversionRate(SourceCurrency: string, DestCurrency: string, Date: Date): Observable<BaseDataResponse<number>>
    {
        //Shortcut
        if (SourceCurrency == DestCurrency)
        {
            var x = new BaseDataResponse<number>();
            x.IsSuccess = true;
            x.Data = 1;
            return of(x);
        }

        //Execute
        return this.api.ExecuteGetAction(this.ControllerName, 'CalculateConversionRate', { SourceCurrency: SourceCurrency, DestCurrency: DestCurrency, Date: Date });
    }

    GetItemPrice(ItemCode: string, CardCode: string, Date: Date, Quantity: number): Observable<BaseEntityResponse<ItemPriceInfo>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetItemPrice', { ItemCode: ItemCode, CardCode: CardCode, Date: Date, Quantity: Quantity });
    }

    GetItemPriceEx(ItemID: number, CustomerID: number, Date: Date, Quantity: number): Observable<BaseEntityResponse<ItemPriceInfo>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetItemPriceEx', { ItemID: ItemID, CustomerID: CustomerID, Date: Date, Quantity: Quantity });
    }
     
}